"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OkxwalletInjectConnector = void 0;
const inject_connector_1 = require("./inject-connector");
class OkxwalletInjectConnector extends inject_connector_1.InjectConnector {
    static getConnector() {
        return new OkxwalletInjectConnector();
    }
    constructor() {
        super();
        this.walletName = 'OKX Wallet extension';
        this.walletNameKey = 'walletModal.mobileConnectionModal.connectInjected';
    }
}
exports.OkxwalletInjectConnector = OkxwalletInjectConnector;
